import { GynecologicalEncounterVitalsSignQuestionsLinkIds } from "@/encounters/constants/gynecological-encounter";
import { isVitalValuePresentForDisplay } from "@/encounters/utils/assessments-vitals";
import { BodyHeightUnitChoices } from "@/encounters/zod-schemas/encounter-answers";
import { getQuestionnaireResponseAnswersSimplified } from "@/utils/medplum";

type GynecologicalVitalsAnswers = ReturnType<typeof getQuestionnaireResponseAnswersSimplified>;

/**
 * Formats weight from gynecological vitals questionnaire answers for display.
 */
export function formatGynecologicalWeightDisplay(
  answers: GynecologicalVitalsAnswers,
): string | undefined {
  const weight =
    answers[GynecologicalEncounterVitalsSignQuestionsLinkIds.GynecologicalWeight]?.value[0];
  const weightUnit =
    answers[GynecologicalEncounterVitalsSignQuestionsLinkIds.GynecologicalWeightUnit]?.value[0];

  if (!isVitalValuePresentForDisplay(weight) || !weightUnit) {
    return undefined;
  }

  return `${weight} ${weightUnit}`;
}

/**
 * Formats height from gynecological vitals questionnaire answers for display.
 */
export function formatGynecologicalHeightDisplay(
  answers: GynecologicalVitalsAnswers,
): string | undefined {
  const heightUnit =
    answers[GynecologicalEncounterVitalsSignQuestionsLinkIds.GynecologicalHeightUnit]?.value[0];
  const heightFeet =
    answers[GynecologicalEncounterVitalsSignQuestionsLinkIds.GynecologicalHeightFeet]?.value[0];
  const heightInches =
    answers[GynecologicalEncounterVitalsSignQuestionsLinkIds.GynecologicalHeightInches]?.value[0];
  const heightCm =
    answers[GynecologicalEncounterVitalsSignQuestionsLinkIds.GynecologicalHeightCm]?.value[0];

  if (heightUnit === BodyHeightUnitChoices.Centimeters && isVitalValuePresentForDisplay(heightCm)) {
    return `${heightCm} cm`;
  }

  if (
    heightUnit === BodyHeightUnitChoices["Feet and Inches"] &&
    (isVitalValuePresentForDisplay(heightFeet) || isVitalValuePresentForDisplay(heightInches))
  ) {
    return `${heightFeet ?? 0}' ${heightInches ?? 0}"`;
  }

  return undefined;
}
